import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { PaymentDetails } from '@/lib/api/payments';
import { TransactionsList, TransactionItemData } from '@/components/transactions';

interface PaymentTransactionsCardProps {
  payment: PaymentDetails;
}

export function PaymentTransactionsCard({ payment }: PaymentTransactionsCardProps) {
  const { t } = useTranslation('payments');

  // Map payment transactions to TransactionItemData format
  const transactions: TransactionItemData[] = payment.transactions.map((transaction) => ({
    id: transaction.id,
    type: transaction.type,
    status: transaction.status,
    amount: transaction.amount,
    result: transaction.result,
    createdAt:
      transaction.createdAt instanceof Date
        ? transaction.createdAt.toISOString()
        : String(transaction.createdAt),
    externalTransactionId: transaction.externalTransactionId || undefined,
    authorizationCode: transaction.authorizationCode || undefined,
    processor: (transaction as any).processor,
    error: (transaction as any).error,
    // Pass all additional fields for TransactionDetails
    ...(transaction as any),
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('transactions')}</CardTitle>
        <CardDescription>{t('transactionsDescription')}</CardDescription>
      </CardHeader>
      <CardContent>
        <TransactionsList transactions={transactions} currency={payment.currency} expandable={true} />
      </CardContent>
    </Card>
  );
}
